import { useCallback, useContext, useState } from "react";
import { AuthContext, AuthContextValue } from "./AuthProvider";
import { ApiError, toApiError } from "../network/mainClient/apiError";
import { TFactor } from "../models/Factors";

export const useGetOperationsFactor = (): [
  TFactor | null,
  boolean,
  ApiError | null,
  () => Promise<void>
] => {
  const { getOperationsFactor } = useContext<AuthContextValue>(AuthContext);
  const [factor, setFactor] = useState<TFactor | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);

  const request = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await getOperationsFactor();
      setFactor(response.factor);
    } catch (e) {
      setError(toApiError(e));
      throw e;
    }
    setIsLoading(false);
  }, [getOperationsFactor]);

  return [factor, isLoading, error, request];
};
